import { z } from 'zod';
import { PaginatedResponseBuilder, paginationParamsSchema } from '../shared.types';

// ---- Contact ----

export const contactSchema = z
    .object({
        userId: z.number().int(),
        firstName: z.string(),
        lastName: z.string(),
        jobTitle: z.string().optional().nullable(),
        phoneNumber: z.string().optional().nullable(),
        emailAddress: z.string().optional().nullable(),
        isActive: z.boolean().optional().nullable(),
    })
    .passthrough();

export type Contact = z.infer<typeof contactSchema>;

// ---- Search request ----

export const contactSearchRequestSchema = paginationParamsSchema.extend({
    locationKey: z.string(),
});

export type ContactSearchRequest = z.infer<typeof contactSearchRequestSchema>;

// ---- Paginated search response ----

export const contactSearchResponseSchema = PaginatedResponseBuilder(contactSchema);

export type ContactSearchResponse = z.infer<typeof contactSearchResponseSchema>;
